var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { st, classes } from './Text.st.css';
import { TPAComponentsConsumer, TPAComponentsContext, } from '../TPAComponentsConfig';
import { TextPriority, TextTypography } from './types';
var DEFAULT_TAG_NAME = 'span';
var Text = /** @class */ (function (_super) {
    __extends(Text, _super);
    function Text() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Text.prototype.render = function () {
        var _this = this;
        var _a = this.props, typography = _a.typography, priority = _a.priority, tagName = _a.tagName, children = _a.children, className = _a.className, role = _a.role, id = _a.id, ariaLabel = _a["aria-label"], ariaHidden = _a["aria-hidden"], rest = __rest(_a, ["typography", "priority", "tagName", "children", "className", "role", "id", 'aria-label', 'aria-hidden']);
        var isAriaHidden = ariaHidden && ariaHidden !== 'false';
        return (React.createElement(TPAComponentsConsumer, null, function (_a) {
            var mobile = _a.mobile;
            return (React.createElement(React.Fragment, null,
                React.createElement(tagName || DEFAULT_TAG_NAME, __assign({ className: st(classes.root, {
                        typography: typography,
                        priority: priority,
                        mobile: mobile,
                    }, className), 'aria-hidden': isAriaHidden || !!ariaLabel, 
                    // for backwards compatibility
                    'aria-label': ariaLabel, 'data-hook': _this.props['data-hook'], role: role, id: id }, rest), children),
                !isAriaHidden && ariaLabel ? (React.createElement("span", { className: classes['sr-only'], "data-sr-only": "true", "data-hook": "".concat(_this.props['data-hook'] || 'wut-text', "-aria-label") }, ariaLabel)) : null));
        }));
    };
    Text.contextType = TPAComponentsContext;
    Text.displayName = 'Text';
    Text.defaultProps = {
        typography: TextTypography.runningText,
        priority: TextPriority.primary,
    };
    return Text;
}(React.Component));
export { Text };
//# sourceMappingURL=Text.js.map